import { render, staticRenderFns } from "./Taxis.view.vue?vue&type=template&id=38c59917"
import script from "./Taxis.view.vue?vue&type=script&lang=ts"
export * from "./Taxis.view.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports